import styled from "styled-components";

import { CheckboxContainer } from "pages/[tenant]/payment/components/molecules/OrderBumpCTA/components/CheckboxStyled/styles";

export const OrderBumpCTAContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 100%;

  border-radius: 0.25rem;
`;

const checkColor = (primaryColor, checkoutColor, suffix = "") => {
  if (checkoutColor === "#ffffff") {
    if (primaryColor === "#ffffff") {
      return `#303030${suffix}`;
    } else {
      return `${primaryColor}${suffix}`;
    }
  } else {
    return `${checkoutColor}${suffix}`;
  }
};

export const OrderBumpCTAHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;

  ${CheckboxContainer} {
    padding: 0.75rem;
  }

  :hover {
    cursor: pointer;
  }

  input {
    pointer-events: none;
  }

  background: ${(props) => {
    const primaryColor = props.theme?.colors?.primary;
    const checkoutColor =
      props.theme?.checkoutStepsOffers?.checkoutPrimaryColor;

    return checkColor(primaryColor, checkoutColor);
  }};

  border-radius: 0.25rem 0.25rem 0 0;
`;

export const OrderBumpCTAContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  padding: 0.75rem;

  background: ${(props) => {
    const primaryColor = props.theme?.colors?.primary;
    const checkoutColor =
      props.theme?.checkoutStepsOffers?.checkoutPrimaryColor;

    return checkColor(primaryColor, checkoutColor, "10");
  }};

  border-radius: 0 0 0.25rem 0.25rem;

  gap: 1rem;
`;

export const ProductContainer = styled.div`
  display: flex;

  align-items: center;

  width: 100%;
  gap: 1rem;

  @media (max-width: 515px) {
    flex-wrap: wrap;
  }
`;

export const ProductImage = styled.img`
  width: 9.5625rem;
  height: 5.9185rem;

  border-radius: 0.25rem;
`;

interface GroupColorProps {
  color: string;
}

export const ProductColorGroup = styled.div<GroupColorProps>`
  min-width: 9.5625rem;
  min-height: 5.9185rem;

  border-radius: 0.25rem;
  background: ${(props) => props.color};
`;

export const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  width: 100%;
`;

export const BeforePrice = styled.div`
  display: flex;
  gap: 0.5rem;

  margin: 0;

  justify-content: space-between;

  flex-direction: row;

  flex-wrap: wrap;

  @media (min-width: 691px) and (max-width: 900px) {
    flex-direction: column;
  }
`;

export const BeforePriceSpan = styled.p`
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.console?.cardDescriptionColor} !important;
  margin: 0;
`;

export const Price = styled.strong`
  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.groups?.primaryText};
`;

export const Title = styled.strong`
  width: 100%;
  margin: 0 0 0.5rem;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.groups?.primaryText};
`;

export const WrapperSelect = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 0.5rem;
`;

export const SubTitle = styled.p`
  width: 100%;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0;

  color: ${({ theme }) => theme.groups?.primaryText};
`;

export const WrapperDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const Description = styled.article`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  color: ${({ theme }) => theme?.console?.cardDescriptionColor} !important;

  span,
  p {
    display: inline-block;

    color: ${({ theme }) => theme?.console?.cardDescriptionColor} !important;
  }
`;

export const WrapperOrderBumpCTA = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LabelDescription = styled.div`
  font-family: Inter;
  font-size: 0.875rem;

  font-weight: 600;

  line-height: 1.25rem;

  text-align: left;

  color: ${({ theme }) => theme.groups?.primaryText} !important;
`;
